import React, { Component, Fragment } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Arial from '../../../../../config/fonts/arial';
import ArialBold from '../../../../../config/fonts/arial-bold';
import DejavuBold from '../../../../../config/fonts/dejavu-bold';
import Dejavu from '../../../../../config/fonts/dejavu';
class PrintTranskrip extends Component {
    state = {
        listDataFix: [],
    };

    getParams = () => {
        if (this.props.location.state != undefined) {
            var today = new Date()
            this.setState({
                tglsekarang: today,
                listDataFix: this.props.location.state.list,
                totalsks: this.props.location.state.totalsks,
                totalSKsN: this.props.location.state.totalSKsN,
                ipk: this.props.location.state.ipk,
                totalD: this.props.location.state.totalD,
                totalE: this.props.location.state.totalE,
                predikat: this.props.location.state.predikat,

                namaMhs: this.props.location.state.nama,
                nimMhs: this.props.location.state.nim,
                nina: this.props.location.state.nina ?? "",
                konsentrasi: this.props.location.state.konsentrasi,
                judulTA: this.props.location.state.judulTA ?? "",

                jurusan: this.props.location.state.jurusan,
                aliasJurusan: this.props.location.state.aliasJurusan,
                fakultas: this.props.location.state.fakultas,

                ttl: this.props.location.state.ttl,
                status: this.props.location.state.status,
                tglmsk: this.props.location.state.tglmsk,
                tgllulus: this.props.location.state.tgllulus,

                namadekan: this.props.location.state.namadekan,
                nidndekan: this.props.location.state.nidndekan,
                tgl_cetaktranskrip: this.props.location.state.tgl_cetaktranskrip,
                noijazah: this.props.location.state.noijazah ?? "",
            }, () => {
                this.print()
            })
        }
    }

    print = () => {
        const doc = new jsPDF();

        doc.addFileToVFS("Arial.ttf", Arial.data);
        doc.addFont("Arial.ttf", "Arial", "normal");
        doc.addFileToVFS("Arial-Bold.ttf", ArialBold.data);
        doc.addFont("Arial-Bold.ttf", "Arial-Bold", "normal");
        doc.addFileToVFS("Dejavu-Bold.ttf", DejavuBold.data);
        doc.addFont("Dejavu-Bold.ttf", "Dejavu-Bold", "normal");
        doc.addFileToVFS("Dejavu.ttf", Dejavu.data);
        doc.addFont("Dejavu.ttf", "Dejavu", "normal");

        var width = doc.internal.pageSize.getWidth()

        doc.setFont("Arial-Bold");
        doc.setFontSize(12.6);
        doc.text(this.state.fakultas, width / 2, 62.8, { align: 'center' });

        doc.setFont("Arial");
        doc.setFontSize(11);
        doc.text("Nomor Pokok Perguruan Tinggi : 072023", width / 2, 56.5, { align: 'center' });

        doc.setFont("Arial");
        doc.setFontSize(10);
        doc.text("Nomor SK Ijin Program Studi : 744/KPT/I/2019", width / 2, 68.5, { align: 'center' });

        doc.setFont("Arial-Bold");
        doc.setFontSize(11.2);
        doc.text("TRANSKRIP NILAI", width / 2, 74.3, { align: 'center' });

        doc.setFont("Arial");
        doc.setFontSize(9);
        doc.text(this.state.noijazah, width / 2, 79.7, { align: 'center' });


        doc.autoTable({
            html: '#headerTabel',
            startY: 85,
            theme: 'plain',
            styles: {
                font: 'Arial',
                lineColor: 'black',
                textColor: 'black',
                fontSize: '9.1',
                cellPadding: 1
            },
            margin: { left: 7, right: 7, },
            columnStyles: {
                0: { cellWidth: 28.1 },
                1: { cellWidth: 3 },
                2: { cellWidth: 69, font: 'Arial-Bold' },
                3: { cellWidth: 23.1 },
                4: { cellWidth: 3 },
                5: { font: 'Arial-Bold', fontSize: '8.5' }
            },
        });

        doc.autoTable({
            html: '#tabelTranskrip',
            theme: 'plain',
            startY: doc.lastAutoTable.finalY + 0.5,
            styles: {
                font: 'Arial',
                textColor: 'black',
                cellPadding: { top: 0.4, bottom: 0.4, left: 1.1, right: 1.1 },
                fontSize: '7.6',
            },
            headStyles: {
                valign: 'middle',
                halign: 'center',
                cellPadding: 1.5
            },
            columnStyles: {
                0: { cellWidth: 8.5, halign: 'center' },
                1: { cellWidth: 69.4 },
                2: { cellWidth: 8.5, halign: 'center' },
                3: { cellWidth: 12, halign: 'center' },
                4: { cellWidth: 8.5, halign: 'center' },
                5: { cellWidth: 69.4 },
                6: { cellWidth: 8.5, halign: 'center' },
                7: { cellWidth: 12, halign: 'center' },
            },
            margin: { left: 7, right: 7, },
            willDrawCell: (data) => {
                if (data.column.index != 0 && data.column.index != 4) {
                    doc.setDrawColor(0, 0, 0)
                    doc.setLineWidth(0.2);
                    doc.line(data.cell.x, data.cell.y + data.row.height, data.cell.x, data.cell.y);
                }
                if (data.column.index == 0) {
                    doc.setDrawColor(0, 0, 0)
                    doc.setLineWidth(0.2);
                    doc.line(data.cell.x, data.cell.y + data.row.height, data.cell.x, data.cell.y);
                }
                if (data.column.index == 4) {
                    doc.setDrawColor(0, 0, 0)
                    doc.setLineWidth(0.85);
                    doc.line(data.cell.x, data.cell.y + data.row.height, data.cell.x, data.cell.y);
                }
                if (data.column.index == 7) {
                    doc.setDrawColor(0, 0, 0)
                    doc.setLineWidth(0.2);
                    doc.line(
                        data.cell.x + data.cell.width,
                        data.cell.y,
                        data.cell.x + data.cell.width,
                        data.cell.y + data.cell.height
                    );
                }
                if (data.row.index == 0) {
                    doc.setDrawColor(0, 0, 0);
                    doc.setLineWidth(0.2);
                    doc.line(
                        data.cell.x,
                        data.cell.y,
                        data.cell.x + data.cell.width,
                        data.cell.y
                    );
                }
                var rows = data.table.body;
                if (data.row.index === rows.length - 1) {
                    doc.setDrawColor(0, 0, 0);
                    doc.setLineWidth(0.1);
                    doc.line(
                        data.cell.x,
                        data.cell.y + data.cell.height,
                        data.cell.x + data.cell.width,
                        data.cell.y + data.cell.height
                    );
                }
            },
            didParseCell: function (data) {
                if (data.section === "body" && data.row.index == 0) {
                    data.cell.styles.cellPadding = { top: 2.5, bottom: 0.5, left: 1, right: 1 }
                }
                if (data.section === "head" && data.row.index == 0) {
                    data.cell.styles.font = 'Arial-Bold'
                }
            }
        });

        doc.autoTable({
            html: '#ketTabel',
            theme: 'plain',
            startY: doc.lastAutoTable.finalY + 4,
            styles: {
                font: 'Arial',
                lineColor: 'black',
                textColor: 'black',
                fontSize: '8.6',
                cellPadding: 0.5
            },
            margin: { left: 7, right: 7, },
            columnStyles: {
                0: { cellWidth: 27 },
                1: { cellWidth: 4 },
                2: { font: 'Arial-Bold' },
            },
            didParseCell: function (data) {
                var rows = data.table.body;
                if (data.row.index === rows.length - 6) {
                    data.cell.styles.cellPadding = { bottom: 5, top: 0.5, left: 0.5, right: 0.5 }
                }
            }
        });

        doc.autoTable({
            html: '#ttdTabel',
            theme: 'plain',
            startY: doc.lastAutoTable.finalY - 13.5,
            styles: {
                font: 'Arial-Bold',
                lineColor: 'black',
                textColor: 'black',
                fontSize: '8.0',
                cellPadding: 0.5
            },
            margin: { left: 7, right: 7, },
            columnStyles: {
                0: { cellWidth: 130 },
            },
            didParseCell: function (data) {
                var rows = data.table.body;
                if (data.row.index === rows.length - 1) {
                    data.cell.styles.cellPadding = { top: 20, bottom: 0.5, left: 0.5, right: 0.5 }
                }
            }
        });

        window.open(doc.output('bloburl'), '_blank')
        window.history.go(-1);
    }

    componentDidMount = () => {
        this.getParams()
    }

    render() {
        return (
            <Fragment>
                <div className="col-xl-12" id="kontenKiri">
                    <div className="card card-custom">
                        <div className="card-body">
                            <div id="spinner" className="loader-1 colorful mb-2"
                                style={{ marginTop: '100px' }}
                            >
                                <div className="dot" />
                                <div className="dot" />
                                <div className="dot" />
                            </div>
                            <p style={{ textAlign: 'center', marginBottom: '100px' }}>Loading print...</p>
                        </div>
                    </div>
                </div>
                <div style={{ display: '' }}>
                    <table id="headerTabel">
                        <thead></thead>
                        <tbody className='times'>
                            <tr>
                                <td>Nama Mahasiswa</td>
                                <td> : </td>
                                <td>{this.state.namaMhs}</td>

                                <td>Jenjang</td>
                                <td> : </td>
                                <td>Strata-1 (S1)</td>
                            </tr>
                            <tr>
                                <td>Tempat, Tgl. Lahir</td>
                                <td> : </td>
                                <td>{this.state.ttl}</td>

                                <td>Program Studi</td>
                                <td> : </td>
                                <td>
                                    {
                                        this.state.aliasJurusan == "Manajemen" ?
                                            <td>Manajemen (61201)</td>
                                            :
                                            this.state.aliasJurusan == "Teknik Informatika" ?
                                                <td>Teknik Informatika (55201)</td>
                                                :
                                                this.state.aliasJurusan == "Sistem Komputer" ?
                                                    <td>Sistem Komputer (56201)</td>
                                                    :
                                                    this.state.aliasJurusan == "Desain Komunikasi Visual" ?
                                                        <td>S1 Desain Komunikasi Visual (90241)</td>
                                                        :
                                                        this.state.aliasJurusan == "Akuntansi" ?
                                                            <td>S1 Akuntansi (62201)</td>
                                                            :
                                                            this.state.aliasJurusan
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td>NIM</td>
                                <td> : </td>
                                <td>{this.state.nimMhs}</td>

                                <td>Konsentrasi</td>
                                <td> : </td>
                                <td>{this.state.konsentrasi}</td>
                            </tr>
                            <tr>
                                <td>NINA</td>
                                <td> : </td>
                                <td>{this.state.nina}</td>

                                <td>Status</td>
                                <td> : </td>
                                <td>{this.state.status}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table id="tabelTranskrip">
                        <thead>
                            <tr>
                                <th>
                                    <center>No</center>
                                </th>
                                <th>
                                    <center>Mata Kuliah</center>
                                </th>
                                <th>
                                    <center>SKS</center>
                                </th>
                                <th>
                                    <center>Nilai</center>
                                </th>

                                <th>
                                    <center>No</center>
                                </th>
                                <th>
                                    <center>Mata Kuliah</center>
                                </th>
                                <th>
                                    <center>SKS</center>
                                </th>
                                <th>
                                    <center>Nilai</center>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.listDataFix.map((list, i) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            <center>{list.no}</center>
                                        </td>
                                        <td>{list.matakuliah.toUpperCase()}</td>
                                        <td>
                                            <center>{list.sks}</center>
                                        </td>
                                        <td>
                                            <center>{list.grade}</center>
                                        </td>
                                        {
                                            list.matched == undefined ?
                                                <>
                                                    <td>
                                                        <center>&nbsp;</center>
                                                    </td>
                                                    <td></td>
                                                    <td>
                                                        <center></center>
                                                    </td>
                                                    <td>
                                                        <center></center>
                                                    </td>
                                                </>
                                                :
                                                <>
                                                    <td>
                                                        <center>{list.matched.no}</center>
                                                    </td>
                                                    <td>{list.matched.matakuliah.toUpperCase()}</td>
                                                    <td>
                                                        <center>{list.matched.sks}</center>
                                                    </td>
                                                    <td>
                                                        <center>{list.matched.grade}</center>
                                                    </td>
                                                </>
                                        }
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    <table id="ketTabel">
                        <thead></thead>
                        <tbody className='times'>
                            <tr>
                                <td>Judul Tugas Akhir</td>
                                <td>:</td>
                                <td>{this.state.judulTA}</td>
                            </tr>
                            <tr>
                                <td>Jumlah SKS</td>
                                <td>:</td>
                                <td>{this.state.totalsks}</td>
                            </tr>
                            <tr>
                                <td>IP Kumulatif</td>
                                <td>:</td>
                                <td>{this.state.ipk}</td>
                            </tr>
                            <tr>
                                <td>Predikat</td>
                                <td>:</td>
                                <td>{this.state.predikat}</td>
                            </tr>
                            <tr>
                                <td>Tanggal Masuk</td>
                                <td>:</td>
                                <td>{this.state.tglmsk}</td>
                            </tr>
                            <tr>
                                <td>Tanggal Lulus</td>
                                <td>:</td>
                                <td>{this.state.tgllulus}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table id="ttdTabel">
                        <thead></thead>
                        <tbody className='times'>
                            <tr>
                                <td></td>
                                <td>Malang, {this.state.tgl_cetaktranskrip}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>Dekan,</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    {this.state.namadekan}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Fragment>
        );
    }
}

export default PrintTranskrip;
